import { motion } from "framer-motion";

export const GooseLogo = ({ className = "", onClick }) => (
  <button
    onClick={onClick}
    data-testid="goose-logo"
    className={`font-display font-extrabold tracking-tight text-rose-500 glow-rose ${className}`}
    style={{ letterSpacing: "0.02em" }}
  >
    GOOSE
  </button>
);

const STATUS_MAP = {
  active: { label: "Active", cls: "text-emerald-400 border-emerald-500/40 bg-emerald-500/10" },
  draft: { label: "Draft", cls: "text-slate-400 border-slate-600/40 bg-slate-600/10" },
  frozen: { label: "Freezing", cls: "text-amber-400 border-amber-500/40 bg-amber-500/10" },
  goose_ready: { label: "Goose Ready", cls: "text-rose-400 border-rose-500/40 bg-rose-500/10" },
  billed: { label: "Billed", cls: "text-emerald-400 border-emerald-500/40 bg-emerald-500/10" },
  payment_due: { label: "Payment Due", cls: "text-red-400 border-red-500/40 bg-red-500/10" },
  closed: { label: "Closed", cls: "text-slate-400 border-slate-600/40 bg-slate-600/10" },
  invited: { label: "Invited", cls: "text-amber-400 border-amber-500/40 bg-amber-500/10" },
  onboarding: { label: "Onboarding", cls: "text-amber-400 border-amber-500/40 bg-amber-500/10" },
  rejected: { label: "Rejected", cls: "text-red-400 border-red-500/40 bg-red-500/10" },
  locked: { label: "Fee Locked", cls: "text-amber-400 border-amber-500/40 bg-amber-500/10" },
  paid: { label: "Paid", cls: "text-emerald-400 border-emerald-500/40 bg-emerald-500/10" },
  failed: { label: "Failed", cls: "text-red-400 border-red-500/40 bg-red-500/10" },
  unlocked: { label: "Pending", cls: "text-slate-400 border-slate-600/40 bg-slate-600/10" },
};

export const StatusPill = ({ status, testId }) => {
  const s = STATUS_MAP[status] || { label: status, cls: "text-slate-400 border-slate-600/40 bg-slate-600/10" };
  return (
    <span data-testid={testId} className={`inline-flex items-center gap-1.5 rounded-full border px-3 py-1 text-xs font-semibold uppercase tracking-wider ${s.cls}`}>
      <span className="h-1.5 w-1.5 rounded-full bg-current" />
      {s.label}
    </span>
  );
};

export const SectionLabel = ({ children }) => (
  <p className="text-xs font-semibold uppercase tracking-[0.22em] text-slate-500">{children}</p>
);

export const Spinner = () => (
  <div className="flex items-center justify-center py-16">
    <div className="h-8 w-8 animate-spin rounded-full border-2 border-slate-700 border-t-rose-500" />
  </div>
);

export const Shell = ({ children, className = "" }) => (
  <div className={`relative min-h-screen goose-grain ${className}`}>
    <div className="relative z-10">{children}</div>
  </div>
);

export const FadeIn = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y: 14 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.45, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);
